import 'virtual:uno.css'
import 'vant/lib/index.css'
import '@/styles/root-rem.css'
import '@/styles/vant-override.css'
import '@/styles/49208.css'

import { createApp, watchEffect } from 'vue'
import { createPinia } from 'pinia'
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate'

import { createHead } from '@unhead/vue/client'

import App from './app.tsx'
import router from './router'
import { client } from '@/api/client.gen.ts'

client.setConfig({
  // 开发环境下，使用相对路径，生产环境下使用环境变量中的 API 基础 URL
  baseUrl: import.meta.env.DEV ? '' : import.meta.env.VITE_API_BASE,
})

const app = createApp(App)

const pinia = createPinia()
pinia.use(piniaPluginPersistedstate)
app.use(pinia)
app.use(router)

// SEO：注册 @unhead/vue，页面通过 useSeo()/useHead() 动态设置 title/meta/JSON-LD
const head = createHead()
app.use(head)

// pinia 就绪后，从持久化存储恢复 Authorization header
import { useAuthStore } from '@/stores/auth-store'
useAuthStore().restoreToken()

// 启动时拉一次网站设置（站点名/Logo/客服/底部栏按钮），失败时使用持久化缓存
import { useSiteConfigStore } from '@/stores/site-config-store'
const siteConfigStore = useSiteConfigStore()
siteConfigStore.fetch().catch(() => {})
// 站点 Logo 变更时同步 favicon。
// 注意：document.title 不再在此统一覆盖（否则会盖掉各页面的 SEO 标题）；
// 标题改由 @unhead/vue 管理——app.tsx 设置以站点名为准的全局兜底标题，
// 各页面用 useSeo() 设置专属标题覆盖。
watchEffect(() => {
  if (siteConfigStore.siteLogo) {
    let link = document.querySelector<HTMLLinkElement>("link[rel='icon']")
    if (!link) {
      link = document.createElement('link')
      link.rel = 'icon'
      document.head.appendChild(link)
    }
    link.href = siteConfigStore.siteLogo
  }
})

// 全局 401 拦截：token 过期/无效时清除登录态并跳转登录页
client.interceptors.response.use((response) => {
  if (response.status === 401) {
    const authStore = useAuthStore()
    if (authStore.isLoggedIn) {
      authStore.logout()
      router.push('/login')
    }
  }
  return response
})
;(async () => {
  const naive = (await import('naive-ui')).default
  app.use(naive)

  app.mount(document.getElementById('app') as HTMLElement)
})()
